import { CadastroAsaasComponent } from './../user/cadastro-asaas/cadastro-asaas.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialUiModule } from 'src/app/layout/material-ui/material-ui.module';

import { AtualizaComponent } from 'src/app/user/atualiza/atualiza.component';
import { CadastroComponent } from 'src/app/user/cadastro/cadastro.component';
import { LoginComponent } from 'src/app/user/login/login.component';
import { RecuperaSenhaComponent } from './recupera-senha/recupera-senha.component';
import { TrocaSenhaComponent } from './troca-senha/troca-senha.component';
import { NgxPhoneMaskBrModule } from 'ngx-phone-mask-br';
import { NgxMaskModule } from 'ngx-mask';
import { VetFormComponent } from './vet-form/vet-form.component';

@NgModule({
  declarations: [
    LoginComponent,
    CadastroComponent,
    AtualizaComponent,
    RecuperaSenhaComponent,
    TrocaSenhaComponent,
    CadastroAsaasComponent,
    VetFormComponent
  ],
  imports: [
    CommonModule,
    MaterialUiModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPhoneMaskBrModule,
    NgxMaskModule.forRoot()
  ],
  exports: [
    LoginComponent,
    CadastroComponent,
    AtualizaComponent
  ]
})
export class UserModule { }
